import { useEffect, useId, useRef, type ReactNode } from 'react';
import { IconX } from '../icons';
import s from './Dialog.module.css';

/** Modal dialog: a bottom sheet on phones, a centred modal on wider screens. */
export function Dialog({ open, onClose, title, description, children, footer, closeLabel = 'Close' }: { open: boolean; onClose(): void; title: ReactNode; description?: ReactNode; children?: ReactNode; footer?: ReactNode; closeLabel?: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  // Unique per dialog: a dialog opened over another must not take the other's title as its name.
  const titleId = useId();
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={s.dialog}
      // Only this dialog's own close: a dialog opened inside it closing must not close this one too.
      onClose={(e) => e.target === ref.current && onClose()}
      onClick={(e) => e.target === ref.current && onClose()} aria-labelledby={titleId}>
      <div className={s.head}>
        <div>
          <h2 id={titleId} className={s.title}>
            {title}
          </h2>
          {description && <p className={s.desc}>{description}</p>}
        </div>
        <button className={s.close} onClick={onClose} aria-label={closeLabel}>
          <IconX />
        </button>
      </div>
      {children && <div className={s.body}>{children}</div>}
      {footer && <div className={s.footer}>{footer}</div>}
    </dialog>
  );
}
